import Head from "next/head";
import React from "react";
import Login from "@/components/Layout/Login";
import Signup from "@/components/Signup";
import { TFunction } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const SignupPage = (): React.ReactElement => <Signup />;

SignupPage.getLayout = function getLayout(
  page: React.ReactElement,
  t: TFunction
) {
  return (
    <Login title={t("users.signupNoun")}>
      <Head>
        <title>{t("users.signupNoun")} - Accred.eu</title>
      </Head>
      {page}
    </Login>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default SignupPage;
